import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { IconNames, IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, Fonts, Paddings } from '../Label.h'

export const PURCHASE_BADGE_TEST_ID = 'label-purchase-badge'

export const PURCHASE_BADGE_BACKGROUND = Backgrounds.SURFACE_OPACITY_DARK_60

export const PURCHASE_BADGE_PADDING_PAID = Paddings.SIZE_80
export const PURCHASE_BADGE_PADDING_RENTED = Paddings.SIZE_90

export type ILabelPurchaseBadgeProps = ILabelProps

/**
 * Paid (crown) and rented (remaining availability) badges of the content
 * details concept, rendered in the labels row above the title.
 */
export const LabelPurchaseBadge = ({
  title = '',
  background = PURCHASE_BADGE_BACKGROUND,
  color = COLOR.TEXT_ICON_PRIMARY,
  corners = Corners.CORNERS_10,
  font = Fonts.FontXsBold,
  padding = title ? PURCHASE_BADGE_PADDING_RENTED : PURCHASE_BADGE_PADDING_PAID,
  icon = title ? null : IconNames.crown,
  iconSize = IconSizes.small,
  'data-testid': dataTestId = PURCHASE_BADGE_TEST_ID,
  ...rest
}: ILabelPurchaseBadgeProps): JSX.Element => (
  <Label
    title={title}
    background={background}
    color={color}
    corners={corners}
    font={font}
    padding={padding}
    icon={icon}
    iconSize={iconSize}
    data-testid={dataTestId}
    {...rest}
  />
)
